/**
 * StatusBadge - Badge component for audit run and finding status.
 * Phase 19: Enhanced Frontend UI.
 */

import { useLocale } from '../contexts/LocaleContext'
import { statusLabel } from '../lib/i18n'

interface StatusBadgeProps {
  status: string
  className?: string
}

export function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const { locale } = useLocale()
  const statusLower = status.toLowerCase()
  
  const colorMap: Record<string, string> = {
    completed: 'badge-success',
    running: 'badge-info',
    pending: 'badge-default',
    queued: 'badge-default',
    success: 'badge-success',
    failed: 'badge-error',
    partial: 'badge-warning',
    cancelled: 'badge-default',
    timeout: 'badge-error',
    // Finding statuses
    open: 'badge-warning',
    resolved: 'badge-success',
    false_positive: 'badge-default',
    wont_fix: 'badge-default',
    investigating: 'badge-info',
  }
  
  const badgeClass = colorMap[statusLower] || 'badge-default'
  
  return (
    <span className={`badge status-badge ${badgeClass} ${className}`}>
      {locale === 'en'
        ? statusLower.replace(/_/g, ' ').toUpperCase()
        : statusLabel(locale, statusLower)}
    </span>
  )
}
